import React from 'react';

import SectionContainer from '../SectionContainer';
import pictureWhoIsFor from '../../../../assets/picture-who-is-for.png';
import css from './SectionWhoIsItFor.module.css';
import classNames from 'classnames';

const WHO_CARDS = [
  {
    descriptor: 'Когда важно быстро разобраться и сделать правильно',
    mainText: 'для тех, кто переехал',
  },
  {
    descriptor: 'Когда нужны точечные услуги «по месту» и на понятном языке',
    mainText: 'для тех, кто живет в Европе давно',
  },
  {
    descriptor:
      'Чтобы находить клиентов, вести коммуникацию и работать по понятным правилам',
    mainText: 'для специалистов',
  },
];

const SectionWhoIsItFor = props => {
  const { sectionId, className } = props;

  return (
    <SectionContainer id={sectionId} className={classNames(className, css.sectionDark)}>
      <div className={css.outer}>
        <div className="delowo-surface">
          <div className={css.intro}>
            <h2 className="delowo-text--section-title">Для кого подходит</h2>
          </div>
          <div className={css.whoGrid}>
            <div className={css.whoCards}>
              {WHO_CARDS.map(card => (
                <article key={card.descriptor} className="delowo-card--who">
                  <p className="delowo-text--who-descriptor">{card.descriptor}</p>
                  <p className="delowo-text--who-main">{card.mainText}</p>
                </article>
              ))}
            </div>
            <div className={css.imageCol}>
              <img
                src={pictureWhoIsFor}
                alt="Консультация с русскоязычным специалистом DELOWO"
                className={css.sideImage}
              />
            </div>
          </div>
        </div>
      </div>
    </SectionContainer>
  );
};

export default SectionWhoIsItFor;
